import { FC } from 'react';
import { Modal } from 'antd';
import AddBodySize from './addBodySize';
import BodySizeList from './bodySizeList';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadBodySizes } from './bodySizeSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { AppState } from '../../redux/store/rootReducer';
import { loadNuts } from '../Nut/NutSlice';
const BodySizePage: FC = () => {
  const dispatch = useDispatch();
  const { isModalOpen, setModelChange, contextHolder, setEditBodySize, editBodySize } = React.useContext(CommonContext) as CommonContextType;
  const BodySizes = useSelector(
    (state: AppState) => state.BodySizes
  );
  const showModal = () => {
    setModelChange(true);
  };
  const handleCancel = () => {
    setEditBodySize(null)
    setModelChange(false);
  };
  
  React.useEffect(() => {
    dispatch(loadBodySizes());
    dispatch(loadNuts());
  },[dispatch]);
  return (
    <div className='padding' style={{ background: '#ffffff'}}>
      {contextHolder}
      <br></br>
      <h2>Body Size List 
        <button className='top-button' onClick={showModal}>Create</button>
      </h2>
      <br></br>
      <BodySizeList />
      <Modal title={editBodySize?.bodysize_value ? 'Edit Body Size' : 'Create Body Size'} open={isModalOpen} onCancel={handleCancel} maskClosable={false} footer={null}>
        <AddBodySize />
      </Modal>
    </div>
  );
  
};

export default BodySizePage;